import { capitalize } from "lodash";
import React, { FC } from "react";

interface Color {
  name: string;
  hex: string;
  text?: string;
}

const COLORS: Color[] = [
  { name: "gray", hex: "#1f2937" },
  { name: "red", hex: "#7f1d1d" },
  { name: "orange", hex: "#7c2d12" },
  { name: "amber", hex: "#78350f" },
  { name: "yellow", hex: "#713f12" },
  { name: "lime", hex: "#365314" },
  { name: "green", hex: "#22543d" },
  { name: "emerald", hex: "#064e3b" },
  { name: "teal", hex: "#134e4a" },
  { name: "cyan", hex: "#164e63" },
  { name: "sky", hex: "#0c4a6e" },
  { name: "blue", hex: "#1e3a8a" },
  { name: "indigo", hex: "#312e81" },
  { name: "violet", hex: "#4c1d95" },
  { name: "purple", hex: "#581c87" },
  { name: "fuchsia", hex: "#701a75" },
  { name: "pink", hex: "#831843" },
  { name: "rose", hex: "#881337" },
];

const LYRICS_COLORS: Color[] = [
  { name: "gray", hex: "#9ca3af", text: "#1f2937" },
  { name: "red", hex: "#f87171", text: "#7f1d1d" },
  { name: "orange", hex: "#fb923c", text: "#7c2d12" },
  { name: "amber", hex: "#fbbf24", text: "#78350f" },
  { name: "yellow", hex: "#facc15", text: "#713f12" },
  { name: "lime", hex: "#a3e635", text: "#365314" },
  { name: "green", hex: "#68d391", text: "#22543d" },
  { name: "emerald", hex: "#34d399", text: "#064e3b" },
  { name: "teal", hex: "#2dd4bf", text: "#134e4a" },
  { name: "cyan", hex: "#22d3ee", text: "#164e63" },
  { name: "sky", hex: "#38bdf8", text: "#0c4a6e" },
  { name: "blue", hex: "#60a5fa", text: "#1e3a8a" },
  { name: "indigo", hex: "#818cf8", text: "#312e81" },
  { name: "violet", hex: "#a78bfa", text: "#4c1d95" },
  { name: "purple", hex: "#c084fc", text: "#581c87" },
  { name: "fuchsia", hex: "#e879f9", text: "#701a75" },
  { name: "pink", hex: "#f472b6", text: "#831843" },
  { name: "rose", hex: "#fb7185", text: "#881337" },
];

export const SimpleColors: FC<{ lyricsColors?: boolean }> = ({
  lyricsColors,
}) => {
  return (
    <ul className="flex flex-wrap gap-2" style={{ padding: 0 }}>
      {(lyricsColors ? LYRICS_COLORS : COLORS).map((c) => (
        <li
          key={c.name}
          style={{ backgroundColor: c.hex, color: c.text ?? "white" }}
          className="m-0 flex h-9 flex-grow items-center justify-center rounded px-2.5 leading-none shadow-glow-dark"
        >
          {capitalize(c.name)}
        </li>
      ))}
    </ul>
  );
};
